module.exports = __webpack_public_path__ + "static/img/kh-007ab.725242f5.jpg";